export default [
  { id: 65, key: 'national-tv' },
  { id: 62, key: 'national-radio' },
  { id: 143, key: 'paid-online' },
  { id: 148, key: 'national-cinema' },
]
